// extracted by mini-css-extract-plugin
module.exports = {"widgetBoxActionButton":"wyq6O7w413CiwpIFRtsDq"};